import React from 'react';

export interface ContainerProps {
  children: React.ReactNode;
  className?: string;
  border?: boolean;
  id?: string;
}

export const Container: React.FC<ContainerProps> = ({
  children,
  className = '',
  border = false,
  id,
}) => (
  <div
    id={id}
    className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 ${
      border ? 'border-t border-slate-200' : ''
    } ${className}`}
  >
    {children}
  </div>
);

export default Container;
